import React, { FC, memo, useState, useCallback } from "react";
import GiveAway from "./GiveAway";
import Thankyou from "./ThankYou";
import { Box } from "@mui/material";
import { environment } from "@environment/environment";

interface MainProps {}

const Main: FC<MainProps> = (props) => {
  const [step, setStep] = useState(1);
  const handleOnChangeStep = useCallback((stepNumber: number) => {
    setStep(stepNumber);
  }, []);

  return (
    <>
      {step === 1 && <GiveAway onChangeStep={handleOnChangeStep} />}
      {step === 2 && <Thankyou />}
      <Box display="none" visibility="hidden" p={0} m={0}>
        Build No. {environment.buildNo}
      </Box>
    </>
  );
};

export default memo(Main);
